var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcWebRescuevehicles(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.122 10.158-7.806 5.618 1.534 2.13 6.784-4.882 18.349 5.082.7-2.53-19.56-5.418z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.939 21.218v1.847h-7.397v1.845h8.117l.925-2.77h4l-.624 6.227-7.132 2.357-.07.24a4.626 4.626 0 0 1-4.178 3.172l-.114.002v1.85h-1.849V34.14h-1.85v1.846H17.92v-1.846h-.463a4.62 4.62 0 0 1-4.623-4.616 4.62 4.62 0 0 1 4.623-4.615h3.236v-1.845h-7.397v-1.847H29.94zm-13.87 8.308c0-1.02.828-1.846 1.85-1.846 1.02 0 1.849.827 1.849 1.846 0 1.02-.828 1.846-1.85 1.846a1.848 1.848 0 0 1-1.849-1.846z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.145 34.603c0 1.093.205 1.407.818 1.39l.106-.006h11.096v1.847l-11.019-.004c-1.783.149-2.78-1.015-2.847-3.01l-.004-.217h1.85z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcWebRescuevehicles);
export default __webpack_public_path__ + "static/media/ic-web-rescuevehicles.03c496d0aca190f7769b9a0a1fb53e68.svg";
export { ForwardRef as ReactComponent };